exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".-col-group{display:inline-block;margin-bottom:5px;padding:0;width:150px;vertical-align:top}.-col-group-title{display:block;margin:5px;padding:5px;border-bottom:1px solid #ddd;font-size:18px}.-col-group>li{margin-bottom:5px;padding-left:10px;list-style:none;line-height:20px;font-size:12px}.-col-group>li>*{margin:0;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-270681a8!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue2-datatable-component/src/HeaderSettings/ColumnGroup.vue
// module id = 855
// module chunks = 2